const INITIAL_STATE = {
    sections : [
        {
            title: 'Restaurants',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 1,
            linkUrl: 'shop/hats'
    
        },
        {
            title: 'Mobile Recharge',
            // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
            imageUrl: 'images/jackets.png', // local file in public/images/
            id: 3,
            linkUrl: 'shop/mobile%20recharge'
        },
        {
            title: 'Grocery',
            // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
            imageUrl: 'images/sneakers.png', // local file in public/images/
            id: 2,
            linkUrl: 'shop/grocery'
        }
    ]
};
const directoryReducer = (state = INITIAL_STATE,action) => {
    switch(action.type){
        default:
            return state;
    }
}
export default directoryReducer;